var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-container"},[(_vm.isIframeVisible)?_c('iframe',{staticClass:"game-iframe",attrs:{"src":_vm.gameUrl,"frameborder":"0","allowFullscreen":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }